export default {"src":"/_next/static/media/piggyBank_64.07751c86.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};